import type { PasswordResetResponse } from 'backend/types'
import { api } from './client'

export async function forgotPassword(email: string): Promise<PasswordResetResponse> {
  const { data } = await api.post<PasswordResetResponse>('/auth/forgot-password', { email })
  if (data && data.success === false) {
    // Normalize to error to trigger UI error path
    const err = new Error((data as any).message)
    ;(err as any).cooldownMinutes = (data as any).cooldownMinutes
    throw err
  }
  return data
}

export async function resetPassword(
  token: string,
  newPassword: string,
): Promise<PasswordResetResponse> {
  try {
    const response = await api.post<PasswordResetResponse>('/auth/reset-password', {
      token,
      newPassword,
    })
    return response.data
  }
  catch (error: any) {
    throw new Error(error.response?.data?.error || 'Failed to reset password')
  }
}

export async function validateSetupToken(token: string): Promise<{ valid: boolean }> {
  try {
    const response = await api.get<{ valid: boolean }>(`/auth/validate-setup-token`, {
      params: { token },
    })
    return response.data
  }
  catch (error: any) {
    if (error?.response) throw error
    throw new Error('Network error')
  }
}

export async function completeAccountSetup(
  token: string,
  password: string,
): Promise<{ success: boolean, message?: string }> {
  try {
    const response = await api.post<{ success: boolean, message?: string }>(
      '/auth/complete-account-setup',
      { token, password, confirmPassword: password },
    )
    return response.data
  }
  catch (error: any) {
    if (error?.response) throw error
    throw new Error('Network error')
  }
}
